export const cbtURL = "https://cbt3.cyberschool.com.au/#!";
export const cbtControllerURL = "https://cbt3.cyberschool.com.au";
